<template>
  <RootTemplate
    show-logo
    class="flex-nowrap minimum-height"
  >
    <ShowHideBuilder />
    <Spinner
      v-if="!appLoaded"
      data-test="app-spinner"
    />
    <FaqModal />
    <SearchModal />
    <SplashScreenModal />
    <FilterByCategoryModal />

    <b-row
      v-if="appLoaded"
      id="mainContent"
      no-gutters
      class="flex-nowrap mh-100 h-100 minimum-height"
    >
      <SidePanel v-if="!hideSidePanel" />
      <SideTabs :cols="sideTabCols" />
      <MainPanel
        :hide-header="hideHeader"
        :header-panel="headerPanel"
      >
        <template v-slot>
          <Spinner
            v-if="!dataLoaded"
            data-test="data-spinner"
          />
          <slot v-if="dataLoaded" />
        </template>
      </MainPanel>
    </b-row>
  </RootTemplate>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import RootTemplate from '@/components/public/Layouts/RootTemplate.vue'
import SplashScreenModal from '@/components/public/SplashScreenModal.vue'
import Spinner from '@/components/public/Spinner.vue'
import SearchModal from '@/components/public/SearchModal.vue'
import ShowHideBuilder from '@/components/builder/ShowHideBuilder.vue'
import FaqModal from '@/components/public/FaqModal.vue'
import SidePanel from '@/components/public/DesktopLayout/SidePanel.vue'
import SideTabs from '@/components/public/SideTabs/SideTabs.vue'
import MainPanel from '@/components/public/DesktopLayout/MainPanel.vue'
import FilterByCategoryModal from '@/components/public/FilterByCategory/FilterByCategoryModal.vue'
import { StoryKeys } from '@/types'

const components = {
  RootTemplate,
  ShowHideBuilder,
  Spinner,
  SearchModal,
  SplashScreenModal,
  FaqModal,
  SidePanel,
  SideTabs,
  MainPanel,
  FilterByCategoryModal,
}

const props = {
  headerPanel: {
    type: String,
    default: StoryKeys.ABOVE_BUBBLES,
  },
  hideSidePanel: Boolean,
  hideHeader: Boolean,
}

@Component({ components })
export default class DesktopLayout extends Vue.extend({ props }) {
  mounted () {
    this.$typedStore.public.size.recalculate()
  }

  updated () {
    this.$typedStore.public.size.recalculate()
  }

  get appLoaded () {
    return this.$typedStore.primary.app.appLoaded
  }

  get dataLoaded () {
    if (this.$typedStore.activeVisualisation.visualisationStore.app.isVisualisationApp) {
      return this.$typedStore.visualisationData.dataLoaded
    } else {
      return true
    }
  }

  get tabHeight () {
    const height = this.$typedStore.public.size.contentHeight
    const numberOfTabs = this.$typedStore.primary.entities.tabs.visibleTabs.length
    return (height / numberOfTabs)
  }

  get tooBig () {
    return this.tabHeight < 70
  }

  get msieversion () {
    return this.$typedStore.public.size.msieversion
  }

  get mode () {
    return (this.msieversion) && this.tooBig
  }

  get sideTabCols () {
    if (this.mode) return '3'
    else if (this.msieversion) return '2'
    else return 'auto'
  }
}

</script>
